<div class="gap-4 grid lg:grid-cols-2">
    @if (blogPostsResource.isLoading()) {
        @for (i of [0, 1, 2, 3]; track $index) {
            <ngx-skeleton-loader
                [theme]="{ height: '15rem', width: '100%' }"
            ></ngx-skeleton-loader>
        }
    } @else if (blogPostsResource.hasValue()) {
        @for (blogPost of blogPostsResource.value().data; track $index) {
            <app-blog-post
                [attr.data-aos]="$index % 2 === 0 ? 'fade-right' : 'fade-left'"
                [blogPost]="blogPost"
            ></app-blog-post>
        }
    }
</div>
